import { Collection } from '../collection';
import { CollectionAction } from '../collection-action.interface';
import { CollectionState } from '../collection-state.interface';

const onUpdateListSuccess = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => ({
  ...state,
  isUpdating: false,
  listOfCollections: (action.collections as Collection[]).map(
    (collection) => {
      const newCollection = { ...collection };
      if (!newCollection.assets || !newCollection.assets.length) {
        const oldCollection = state.listOfCollections.find(
          (b) => b.collectionId === newCollection.collectionId,
        );
        newCollection.assets = (oldCollection && oldCollection.assets) || [];
      }

      return newCollection;
    },
  ),
});

export default onUpdateListSuccess;
